if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.form.querySelector("[name=id]").disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        const submitButton = this.querySelector('[type="submit"]');
        if (submitButton.classList.contains("loading")) return;

        this.handleErrorMessage();

        submitButton.setAttribute("aria-disabled", true);
        submitButton.classList.add("loading");
        this.querySelector(".loading-overlay__spinner").classList.remove(
          "hidden"
        );

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);
        formData.append("sections_url", window.location.pathname);
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.handleErrorMessage(response.description);
              return;
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            submitButton.classList.remove("loading");
            submitButton.removeAttribute("aria-disabled");
            this.querySelector(".loading-overlay__spinner").classList.add(
              "hidden"
            );
            customElements.get("side-cart").prototype.refreshCart();
          });
      }

      handleErrorMessage(errorMessage = false) {
        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}

document.addEventListener("DOMContentLoaded", () => {
  let current_select = document.querySelector(
    ".select-variants .select__select"
  );
  let select = document.querySelector(".select-values");
  let select_items = document.querySelectorAll(".select-values label");
  if (current_select) {
    current_select.addEventListener("click", () => {
      select.classList.toggle("open");
    });

    select_items.forEach((item) => {
      item.addEventListener("click", (e) => {
        select.classList.remove("open");
        const _for = e.currentTarget.getAttribute("for");
        const _input = document.querySelector(`select[name="${_for}"]`);

        select_items.forEach((item) => {
          item.classList.remove("actif");
        });

        if (_input) {
          e.currentTarget.classList.add("actif");
          _input.value = e.currentTarget.getAttribute("value");
          _input.dispatchEvent(new Event("change"));
          _input.closest("variant-selects").dispatchEvent(new Event("change"));
          current_select.querySelector("label").textContent =
            e.currentTarget.textContent;
        }
      });
    });
  }

  // check if click outside select and close it
  document.addEventListener("click", (e) => {
    if (e.target.closest(".select-variants")) return;
    if (select) {
      select.classList.remove("open");
    }
  });
});
